import styled from '@emotion/styled';
import { SvyIcon } from '@innovorder/savory';
import { Text } from 'components';

export const PageWithBottomBarContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const GrowingContainer = styled.div`
    flex: 1;
`;

export const BottomBarContainer = styled.div`
    box-shadow: ${({ theme }) => theme.base.shadow.outside[300]};
`;

export const StyledBottomBar = styled(BottomBarContainer)`
    backdrop-filter: blur(3.5px);
    background: rgba(255, 255, 255, 0.4);
    position: sticky;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    bottom: 0;
    z-index: 3;
`;

export const BottomBarChildren = styled.div<{ withPadding?: boolean }>`
    width: 100%;
    padding: ${({ theme, withPadding }) => withPadding && theme.base.spacing[2]}
        ${({ theme, withPadding }) => withPadding && theme.base.spacing[2]};

    /**
    env(safe-area-inset-bottom) is a global variable exposed by iOS browsers
    It is used to handle the safe area of the bottom of the screen
    Which fixes the issues of position sticky & bottom 0 that goes under browser bottom bar
    */

    @supports (padding-bottom: env(safe-area-inset-bottom)) {
        padding-bottom: calc(
            env(safe-area-inset-bottom) +
                ${({ theme, withPadding }) => withPadding && theme.base.spacing[2]}
        ) !important;
    }
`;

export const StyledIcon = styled(SvyIcon)`
    font-size: 24px;
    margin-right: ${({ theme }) => theme.base.spacing[2]};
`;

export const StyledText = styled(Text)`
    text-align: center;
`;

export const DisabledOverlay = styled.div`
    width: 100%;
    height: 100%;
    opacity: 0.5;
    pointer-events: none;
`;
